import React, { useState, useEffect } from 'react';
import axios from '../../api/api';
import { toast } from 'sonner'
import { useParams, useNavigate } from 'react-router-dom'


const UpdateScheduled = () => {

  const { id } = useParams()
  const [account_number, setAccount_number] = useState('')
  const [amount, setAmount] = useState('')
  const [request_push_time, setRequest_push_time] = useState('')
  const [service_id, setService_id] = useState('')
  const navigate = useNavigate()
  const [bundle, setBundle] = useState([])
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const getRequestById = async () => {
      try {
        const response = await axios.get(`/batch_request/scheduled/${id}`)
        setAccount_number(response.data.account_number)
        setAmount(response.data.amount)
        setRequest_push_time(response.data.request_push_time)
        setService_id(response.data.service_id)
      } catch (error) {
        console.log(error)
      }
    }
    getRequestById()
  },[id])

  useEffect(() => {
    const getBundles = async () => {
      try {
        const response = await axios.get('/bundles/');
        setBundle(response.data.items)
      } catch (error) {
        console.log(error);
      }
    };
    getBundles()
  },[])

  // update scheduled request
  const handleSubmit = async (e) => {
    e.preventDefault()
    try {
      setLoading(true);
      const response = await axios.put(`/batch_request/scheduled/${id}`,
        { account_number, amount, request_push_time }
      )
      toast.success(response.data.message)
      navigate('/app/scheduleairtime')
    } catch (error) {
      console.log(error)
      if (!error?.response) {
        toast.error('Network error! Check your connection.');
      } else if (error.response.status === 400 || 404) {
        toast.error(error.response.data.detail)
      } else {
        toast.error('Oops! Something went wrong. Schedule failed.')
      }
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className='mx-auto p-4'>
      <h3>Update scheduled request</h3>
      <section className="bg-white p-4 rounded-lg mt-4">
        <form onSubmit={handleSubmit}>
          <div className="flex items-center">
            <div className='p-2 w-full'>
              <label htmlFor='number'><span>Phone Number</span>
                <input
                  type='number'
                  required
                  placeholder='070000000'
                  className='px-3 py-2 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-[#165277] focus:ring-[#165277] block w-full rounded-md sm:text-sm focus:ring-1'
                  value={account_number}
                  onChange={(e) => setAccount_number(e.target.value)}
                />
              </label>
            </div>
            {service_id === "2" ? (
              <div className='p-2 w-full'>
                <label htmlFor='amount'><span>Amount</span>
                  <input
                    type='number'
                    required
                    placeholder='Amount'
                    className='px-3 py-2 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-[#165277] focus:ring-[#165277] block w-full rounded-md sm:text-sm focus:ring-1'
                    value={amount}
                    onChange={(e) => setAmount(e.target.value)}
                  />
                </label>
              </div>
            ) : (
              <div className='p-2 w-full'>
                <label htmlFor='amount'><span>Bundle Amount</span>
                  <select 
                    name="service" id="service"
                    className='px-3 py-2 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-[#165277] focus:ring-[#165277] block w-full rounded-md sm:text-sm focus:ring-1'
                    value={amount}
                    onChange={(e) => setAmount(e.target.value)}
                  >
                    <option value="">Select..</option>
                    {bundle.map((bundles) => (
                      <option key={bundles.id} value={bundles.value}>{bundles.code}</option>
                    ))}
                  </select>
                </label>
              </div>
            )}
          </div>
          <div className='p-2 w-full'>
            <label htmlFor='date'><span>Date and Time</span>
              <input
                type='datetime-local'
                required
                placeholder='datetime'
                className='px-3 py-2 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-[#165277] focus:ring-[#165277] block w-full rounded-md sm:text-sm focus:ring-1'
                value={request_push_time}
                onChange={(e) => setRequest_push_time(e.target.value)}
              />
            </label>
          </div>
          <div className='my-4 text-center'>
            <button disabled={loading} className='bg-[#134463] text-white px-5 py-2 rounded-lg text-md hover:bg-[#165277]'>{loading ? 'updating' : 'Update Scheduled Request'}</button>
          </div>
        </form>
      </section>
    </div>
  )
}

export default UpdateScheduled
